var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.$store.state.stripe_card_expired &&
      _vm.autoRenewalEnabled &&
      !_vm.$route.meta.hideNav
  )?_c('b-container',{staticClass:"mt-3"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-alert',{attrs:{"dismissible":"","variant":"info","show":""}},[_vm._v(" Your account's credit card has expired. Please review your "),_c('b-link',{attrs:{"to":{ name: 'account' }}},[_vm._v("account settings")]),_vm._v(" now. ")],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }